import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/reset.css'
import './assets/animate.css'
import echarts from 'echarts'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui';

Vue.prototype.$echarts=echarts;
Vue.config.productionTip = false;
Vue.use(ElementUI, {
    size: 'small',
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
